import React from "react"

import { TooltipWithChildrenContainer, TooltipWithChildrenContainerProps } from "./TooltipWithChildrenContainer"

type TooltipProps = TooltipWithChildrenContainerProps & { offset?: [number, number] }

export const Tooltip = ({ offset, ...props }: TooltipProps) =>
  <TooltipWithChildrenContainer {...props} {...offset && {
    PopperProps: {
      modifiers: [{
        name: "offset",
        options: {
          offset
        }
      }],
      ...props.PopperProps,
    }
  }} />
